import { useMemo } from 'react';
import { useCompanyCustomFieldsAsFilterableFields } from './custom-fields';
import { useCompanyNativeFieldsAsFilterableFields } from './default-fields';

export const ExcludedCompanyFieldsForFilter = [
  'csatRating',
  'lastMilestoneCSAT',
  'recentRiskSignals',
  'recentOpportunitySignals',
  'recentOperationalSignals',
];

export const CompanyFields = {
  companyName: 'companyName',
  description: 'description',
  accountOwner: 'accountOwner',
  customerMembers: 'customerMembers',
  health: 'companyHealth',
  stage: 'companyStage',
  annualizedRecurringRevenue: 'annualizedRecurringRevenue',
  champions: 'champions',
  nextRenewalDate: 'contractRenewalDate',
  overAllProjectRating: 'csatRating',
  lastMilestoneCSAT: 'lastMilestoneCSAT',
  joinedAt: 'createdAt',
  trackedHours: 'trackedMinutes',
  billableHours: 'billableMinutes',
  totalAllocatedHours: 'allocatedMins',
  actualRevenue: 'actualRevenue',
  estimatedRevenue: 'estimatedRevenue',
  actualProfit: 'actualProfit',
  estimatedProfit: 'estimatedProfit',
  actualProfitMargin: 'actualMargin',
  estimatedProfitMargin: 'estimatedMargin',
  actualCost: 'actualCost',
  estimatedCost: 'estimatedCost',
  companyNote: 'companyNote',
  lastActivityDate: 'lastActivityDate',
  recentRiskSignals: 'recentRiskSignals',
  recentOpportunitySignals: 'recentOpportunitySignals',
  recentOperationalSignals: 'recentOperationalSignals',
};

export const useCompanyFieldsAsFilterableField = () => {
  const { fields: nativeFields, loading: nativeFieldsLoading } =
    useCompanyNativeFieldsAsFilterableFields();
  const { fields: customFields, loading: customFieldsLoading } =
    useCompanyCustomFieldsAsFilterableFields();

  return useMemo(
    () => ({
      fields: nativeFields.concat(customFields),
      loading: nativeFieldsLoading || customFieldsLoading,
    }),
    [customFields, customFieldsLoading, nativeFields, nativeFieldsLoading],
  );
};
